import { useSelector } from "react-redux"
import { useTranslation } from "react-i18next"

import {
  selectBestResearchBuildingLevel,
  selectCurrentTeam,
  selectResearchPerRound,
  selectResearchPoints,
} from "src/store/game"

import Modal from "src/components/modals/Modal"
import ResearchPanel from "src/components/ResearchPanel"

import "src/components/ResearchPanel.css"

/* Research is executed here — the global screen behind the points counter — not inside any one
   academy. The points are a per-player pool and the upgrades apply everywhere, so the place to
   spend them is where the pool is shown; the academy's modal is about the building: it generates
   the points and levels up, nothing else. */

const ResearchModal = () => {
  const { t } = useTranslation()
  const points = useSelector(selectResearchPoints)
  const team = useSelector(selectCurrentTeam)
  // Only for the "you have no lab anywhere" warning and the panel's own gate — not for the rate,
  // which is the empire's (owner, 2026-09-10).
  const level = useSelector(selectBestResearchBuildingLevel)
  const perRound = useSelector(selectResearchPerRound)
  const buildingName = team === "human" ? t("game.buildings.academy") : t("game.buildings.evolutionChamber")

  return (
    <Modal width="min(920px, 94%)" isolated={false} scope="map" top="6vh" maxHeight="88vh">
      <div className="research-modal">
        <header className="research-modal-head">
          <h2>{t("game.statDetail.researchTitle")}</h2>
          <div className="research-modal-meta">
            {/* The pool is not money and must not read as it (owner, 2026-09-10): the amber mono
                number beside a rate was a gold counter at a glance, so the pool is plain and the
                microscope names the unit on the rate itself. The title carries no glyph now —
                one icon on this header, on the number it belongs to.

                Two numbers and no third: the pool, and what every base together adds to it each
                round. The building that used to be named here is one of possibly several, and
                naming it made a per-player pool read as one chamber's output. */}
            <span className="research-modal-points">{points}</span>
            <span className="research-modal-rate">
              +{perRound}{" "}
              <span className="research-modal-glyph" role="img" aria-hidden="true">
                🔬
              </span>
              /rd
            </span>
          </div>
        </header>
        {level === 0 && <p className="stat-detail-warning">⚠ {t("game.statDetail.noLab", { building: buildingName })}</p>}
        <ResearchPanel level={level} />
      </div>
    </Modal>
  )
}

export default ResearchModal
